import React from 'react';
import { Button, Card, Typography } from 'antd';
import { VideoCameraOutlined, LinkOutlined } from '@ant-design/icons';

const { Text } = Typography;

const NextcloudTalk = ({ roomName, user, domain = 'https://10.11.1.250' }) => {
  const talkUrl = `${domain}/apps/spreed/`;

  const openInNewTab = () => {
    window.open(talkUrl, '_blank');
  };

  return (
    <div style={{ 
      width: '100%', 
      height: '100%', 
      minHeight: '400px', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      backgroundColor: '#f5f5f5',
      padding: '20px'
    }}>
      <Card 
        style={{ 
          maxWidth: '500px', 
          textAlign: 'center',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
        }}
      >
        <VideoCameraOutlined style={{ fontSize: '64px', color: '#1890ff', marginBottom: '24px' }} />
        <h2 style={{ marginBottom: '16px' }}>Видеоконференция Nextcloud Talk</h2>
        <Text type="secondary" style={{ display: 'block', marginBottom: '24px' }}>
          Для участия в видеоконференции откройте Nextcloud Talk в новой вкладке.
          Убедитесь, что вы вошли в систему Nextcloud.
        </Text>
        <Button 
          type="primary" 
          size="large"
          icon={<LinkOutlined />}
          onClick={openInNewTab}
          style={{
            background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
            border: 'none',
            height: '48px',
            fontSize: '16px'
          }}
        >
          Открыть Nextcloud Talk
        </Button>
        <div style={{ marginTop: '16px' }}>
          <Text type="secondary" style={{ fontSize: '12px' }}>
            {talkUrl}
          </Text>
        </div>
      </Card>
    </div>
  );
};

export default NextcloudTalk;
